export default {
  name: 'account--productGroup',
  apiService: 'account',
  apiPath: '/admin/pg',
};